import React, { useState } from 'react';
import Navbar from '../layout/Navbar';
import Footer from '../layout/Footer';
import { BiLeftArrow } from 'react-icons/bi';
import { ChevronLeft, ChevronRight, FastForward, Rewind } from 'lucide-react';

export default function LabReports() {
  const labReports = [
    { date: '9 Jan 2024', name: 'Complete Blood Count', status: 'Pending' },
    { date: '12 Dec 2023', name: 'Covid Test', status: 'Generated' },
    { date: '2 Dec 2023', name: 'Covid Test', status: 'Generated' },
    { date: '1 Dec 2023', name: 'Complete Blood Count', status: 'Generated' },
    { date: '1 Dec 2023', name: 'Complete Blood Count', status: 'Generated' },
    { date: '1 Dec 2023', name: 'Complete Blood Count', status: 'Generated' },
    { date: '1 Dec 2023', name: 'Complete Blood Count', status: 'Generated' },
    { date: '1 Dec 2023', name: 'Complete Blood Count', status: 'Generated' },
    { date: '1 Dec 2023', name: 'Complete Blood Count', status: 'Generated' },
    { date: '1 Dec 2023', name: 'Complete Blood Count', status: 'Generated' }
  ];

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;
  const totalPages = Math.ceil(labReports.length / itemsPerPage);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = labReports.slice(indexOfFirstItem, indexOfLastItem);

  return (
    <>
      <Navbar />
      <div className="max-w-6xl px-4 mx-auto">
        {/* Breadcrumb */}
        <div className="flex items-center my-3 text-xs text-gray-500">
          <span className="cursor-pointer hover:underline">Home</span>
          <span className="mx-1">/</span>
          <span className="cursor-pointer hover:underline">Patient Portal</span>
          <span className="mx-1">/</span>
          <span className="cursor-pointer hover:underline">My Wellness Space</span>
          <span className="mx-1">/</span>
          <span className="text-gray-700">Lab Reports</span>
        </div>

        {/* Header */}
        <div className="flex items-center mb-4">
          <button className="mr-2 text-gray-700">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M19 12H5M5 12L12 19M5 12L12 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
          <h1 className="text-lg font-medium text-gray-800">Lab Reports</h1>
        </div>

        {/* Lab Reports Table */}
        <div className="overflow-x-auto border border-gray-200 rounded-md shadow-sm">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-100">
              <tr>
                <th scope="col" className="px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-700 uppercase">
                  Lab Test Date
                </th>
                <th scope="col" className="px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-700 uppercase">
                  Report Name
                </th>
                <th scope="col" className="px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-700 uppercase">
                  Result Status
                </th>
                <th scope="col" className="px-6 py-3 text-xs font-medium tracking-wider text-center text-gray-700 uppercase" colSpan="2">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {currentItems.map((report, index) => (
                <tr key={index} className="hover:bg-gray-50">
                  <td className="px-6 py-4 text-sm text-gray-900 whitespace-nowrap">
                    {report.date}
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-900 whitespace-nowrap">
                    {report.name}
                  </td>
                  <td className="px-6 py-4 text-sm whitespace-nowrap">
                    <span className={`text-sm ${report.status === 'Pending' ? 'text-yellow-500' : 'text-green-500'}`}>
                      {report.status}
                    </span>
                  </td>
                  <td className="px-3 py-4 text-sm text-center whitespace-nowrap">
                    <button className="inline-flex items-center justify-center px-3 py-1 text-xs font-medium text-teal-500 rounded-full bg-teal-50">
                      <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path>
                      </svg>
                      View
                    </button>
                  </td>
                  <td className="px-3 py-4 text-sm text-center whitespace-nowrap">
                    <button className="inline-flex items-center justify-center px-3 py-1 text-xs font-medium text-teal-500 rounded-full bg-teal-50">
                      <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z"></path>
                      </svg>
                      Print
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="flex items-center justify-center mt-4 space-x-2">
          <button onClick={() => handlePageChange(1)} disabled={currentPage === 1} className="px-2 py-1 text-sm bg-gray-100 rounded hover:bg-gray-200 disabled:opacity-50"><Rewind /></button>
          <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} className="px-2 py-1 text-sm bg-gray-100 rounded hover:bg-gray-200 disabled:opacity-50"><ChevronLeft /></button>
          {[...Array(totalPages)].map((_, i) => (
            <button
              key={i}
              onClick={() => handlePageChange(i + 1)}
              className={`px-3 py-1 text-sm rounded-full ${currentPage === i + 1 ? 'bg-teal-500 text-white' : 'bg-white text-gray-700 border border-gray-300 hover:bg-gray-100'}`}
            >
              {i + 1}
            </button>
          ))}
          <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} className="px-2 py-1 text-sm bg-gray-100 rounded hover:bg-gray-200 disabled:opacity-50"><ChevronRight /></button>
          <button onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} className="px-2 py-1 text-sm bg-gray-100 rounded hover:bg-gray-200 disabled:opacity-50"><FastForward /></button>
        </div>
      </div>
      <Footer />
    </>
  );
}